import React from 'react';
import PropTypes from 'prop-types';

import RecommendationsCard3Panel from 'Components/Cards/RecommendationsCard3Panel';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

const RecommendationsCarousel3Panel = ({ hitData }) => {
  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    md: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    lg: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    xl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xxl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  };

  if (!hitData) return false;

  if (Array.isArray(hitData) && hitData.length === 0) {
    return (
      <SiteSlider sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
        {[...Array(12).keys()].map(fakeHit =>
          <div className="SkeletonFanFavouriteCardNew" key={fakeHit + 1}>
            <div className="SkeletonFanFavouriteCardNew__cover" />
            <div className="SkeletonFanFavouriteCardNew__content" />
          </div>,
        )}
      </SiteSlider>
    );
  }

  return (
    <SiteSlider sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
      {hitData.map(hit =>
        <RecommendationsCard3Panel
          key={hit.product_id}
          hit={hit}
          sizesOverride="(min-width: 1520px) 420px, (min-width: 1200px) 360px, (min-width: 992px) 460px, (min-width: 768px) 310px, (min-width: 576px) 446px, 98vw"
        />,
      )}
    </SiteSlider>
  );
};

RecommendationsCarousel3Panel.propTypes = {
  hitData: PropTypes.arrayOf(PropTypes.shape({})),
};

RecommendationsCarousel3Panel.defaultProps = {
  hitData: [],
};

export default RecommendationsCarousel3Panel;
